import { InfiniteData } from '@tanstack/query-core';
import { useMutation } from '@tanstack/react-query';
import type { PaginatedList } from '@shared/types/common';
import type { ExerciseVideo } from '@shared/types/exercises';
import { UpdateExerciseVideoDto } from '@src/api/exercises.ts';
import { API } from '@src/api/index.ts';
import { queryClient } from '@src/api/query-client.ts';

export const useUpdateExerciseMutation = () => {
  return useMutation({
    mutationFn: async (params: UpdateExerciseVideoDto) => await API.exercises.update(params),
    onSuccess: async (response, { id }) => {
      queryClient.setQueriesData(
        { queryKey: ['exercises'] },
        (oldData: InfiniteData<PaginatedList<ExerciseVideo>>) => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            pages: oldData.pages.map((page) => ({
              ...page,
              results: page.results.map((item) => {
                if (item.id === response.data.id) {
                  return {
                    ...item,
                    ...response.data,
                  };
                }
                return item;
              }),
            })),
          };
        }
      );

      queryClient.setQueriesData({ queryKey: ['exercise', id] }, (oldData: ExerciseVideo) => {
        if (!oldData) return oldData;
        return {
          ...oldData,
          ...response.data,
        };
      });

      await queryClient.invalidateQueries({ queryKey: ['exercises'] });
      await queryClient.invalidateQueries({ queryKey: ['exercise', id] });
    },
  });
};
